import {MatchData} from '../types/data.ts';
import {MatchDetailsView} from '../../../components/matches/MatchDetailsView';
import type {MatchPartsResponse} from '../../../hooks/useMatchDetails';
import type {MatchBillPart} from '../types/Document.ts';
import type {MatchTransactionPart} from '../../../pages/app/partner/pages/partnerUnmatchedTransactionsPage/types.ts';

interface UnmatchProps {
    data: MatchData;
    currentDocumentId: string;
    onUnmatch: (matchId: string, bills: MatchBillPart[], transactions: MatchTransactionPart[]) => void;
}

export function MatchOverview({data, currentDocumentId, onUnmatch}: UnmatchProps) {
    const match: MatchPartsResponse = {
        match_id: data.matchId,
        transaction_parts: data.transactions as unknown as MatchPartsResponse['transaction_parts'],
        bill_parts: data.bills as unknown as MatchPartsResponse['bill_parts'],
        is_completed: data.isCompleted,
        created_at: data.createdAt,
        completed_at: data.completedAt,
        matching_reason: data.matchingReason,
        created_by_name: data.createdByName,
        business_id: null,
        difference_booking_date: data.differenceBookingDate,
        difference_booking_reason: data.differenceBookingReason,
        difference_booking_gla_id: data.differenceBookingGlaId,
        difference_booking_gla_label: data.differenceBookingGlaLabel,
        nrs_remainder: data.nrsRemainder,
    };

    function handleUnmatchPart(billIds: string[], transactionIds: string[]) {
        const bills = data.bills.filter((b) => billIds.includes(b.id));
        const transactions = data.transactions.filter((t) => transactionIds.includes(t.id));
        onUnmatch(data.matchId, bills, transactions);
    }

    function handleUnmatchAll() {
        onUnmatch(data.matchId, data.bills, data.transactions);
    }

    return (
        <MatchDetailsView
            match={match}
            currentEntityId={currentDocumentId}
            onUnmatchPart={handleUnmatchPart}
            onUnmatchAll={handleUnmatchAll}
        />
    );
}
